import { Injectable } from '@angular/core';
import {
    EventMatchedOfferType,
    EventStage
} from '../../../../common/models/event.interface';
import {
    eventStageLabel,
    targetingLabel
} from '../../../../common/utilities/constants';
import { EventUploadStatus } from '../../../../common/models/bulk-job.interface';

@Injectable()
export class ConstantsService {
    readonly eventMatchedOfferType = EventMatchedOfferType;
    readonly eventUploadStatus = EventUploadStatus;
    readonly eventStage = EventStage;
    readonly downloadSpan = `<span class="k-icon k-i-download"></span>`;
    private id = 0;

    eventStageLabel = eventStageLabel;
    targetingLabel = targetingLabel;

    constructor() {}

    getNextId() {
        return this.id++;
    }
}
